import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  inject,
} from '@angular/core';
import { SessionStorageService } from '../../services/session-storage.service';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { UnitListResponse } from '../../models/admin-models';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AdminService } from '../../admin/admin.service';

@Component({
  selector: 'app-dashboard-filters',
  templateUrl: './dashboard-filters.component.html',
  styleUrls: ['./dashboard-filters.component.scss'],
  imports: [
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    FormsModule,
    MatAutocompleteModule,
  ],
})
export class DashboardFiltersComponent implements OnInit {
  private ss = inject(SessionStorageService);
  private adminService = inject(AdminService);

  @Input() solution;
  @Input() dateRange;
  @Output() changeSolution = new EventEmitter();
  @Output() changeDate = new EventEmitter();
  @Output() changeUnit = new EventEmitter();

  solutions = [];
  filteredUnits;
  unitCtrl = new FormControl();

  ngOnInit() {
    this.ss.get('globals')?.Modules.forEach(el => {
      switch (el.toLowerCase()) {
        case 'aw':
          this.solutions.push({
            label: 'Annuity Wizard',
            value: el.toLowerCase(),
          });
          break;
        case 'iw':
          this.solutions.push({
            label: 'Investment Wizard',
            value: el.toLowerCase(),
          });
          break;
        case 'li':
          this.solutions.push({
            label: 'Life Insurance Wizard',
            value: el.toLowerCase(),
          });
          break;
        case 'pp':
          this.solutions.push({
            label: 'Product Profiler',
            value: el.toLowerCase(),
          });
          break;
        default:
          break;
      }
    });
    if (this.solutions.length > 1) {
      this.solutions.splice(0, 0, { label: 'All', value: 'ALL' });
    }
    if (!this.solutions.find(solution => solution.value === 'ALL'))
      this.solutionChange(this.solutions[0]);
    const globals = this.ss.get('globals');
    this.filteredUnits = globals?.user.managerUnits;
    this.getUnits();
  }

  getUnits() {
    this.unitCtrl.setValue(this.filteredUnits[0].id);
    this.unitCtrl.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(250))
      .subscribe(unit => {
        this._filterUnits(unit);
      });
  }

  private _filterUnits(value: string) {
    this.adminService
      .getUnitList(value, true)
      .subscribe((resp: UnitListResponse) => {
        if (resp.names) {
          this.filteredUnits = resp.names;
        } else {
          this.filteredUnits = [];
        }
      });
  }

  selectUnit(ev) {
    this.changeUnit.emit(ev.option.value);
  }

  solutionChange(ev) {
    this.changeSolution.emit(ev);
  }

  dateChange(ev, position) {
    this.changeDate.emit({
      position: position,
      value: ev.target.value,
    });
  }
}
